<template>
    <el-col :span="24" :lg="lg">
        <v-autocomplete
            :loading="isLoading"
            item-color="green-darken-2"
            :multiple="multiple"
            rounded="sm"
            :clearable="clearable"
            @update:modelValue="updateSelectedItem"
            density="comfortable"
            v-model="selectedItem"
            :label="$t(label)"
            :items="data"
            variant="outlined"
            :hide-details="hideDetails"
            :rules="rules"
        >
            <template v-slot:prepend-inner>
                <i class="ti ti-arrow-up-rhombus"></i>
            </template>
        </v-autocomplete>
    </el-col>
</template>

<script lang="ts">
    import { defineComponent, onMounted, ref, watch } from 'vue'
    import { UserIcon } from 'vue-tabler-icons'
    // import axios from '@/utils/apiClient'
    import axios from '@/utils/apiClient'
    export default defineComponent({
        name: 'sm-user-picker',
        props: {
            modelValue: null,
            label: {
                type: String,
                default: 'Select Workflow',
            },
            status: {
                type: String,
                default: 'all',
            },
            lg: {
                type: String,
                default: '12',
            },
            clearable: {
                type: Boolean,
                default: true,
            },
            required: {
                type: Boolean,
                default: true,
            },
            hideDetails: {
                type: Boolean,
                default: true,
            },
            multiple: {
                type: Boolean,
                default: false,
            },
        },
        setup(props, { emit }) {
            const selectedItem = ref(props.modelValue)
            const isLoading = ref(true)
            const data = ref([])
            const rules = ref()
            const modelValueRef = ref(props.modelValue)

            const x = ref(props.modelValue)
            if (props.required) {
                rules.value = [v => !!v || 'Please select a workflow!']
            }

            const fetchData = async () => {
                //this.post = null;
                isLoading.value = true
                try {
                    axios.get('Workflow').then(response => {
                        if (response.status == 200) {
                            data.value.push(...response.data)
                        }
                    })
                } catch (error) {
                    console.log(error)
                    isLoading.value = false
                }
                isLoading.value = false
            }
            const updateSelectedItem = newValue => {
                selectedItem.value = newValue
                emit('update:modelValue', newValue)
                //if (props.multiple) {
                //    var tmp = newValue.join(',')
                //    emit('update:modelValue', tmp);
                //}
                //else {

                //}
            }

            watch(
                () => props.modelValue,
                newValue => {
                    if (!props.multiple) {
                        selectedItem.value = newValue
                    }
                }
            )

            onMounted(() => {
                fetchData()
            })
            return {
                isLoading,
                selectedItem,
                data,
                rules,
                modelValueRef,
                updateSelectedItem,
            }
        },
    })
</script>
